import api from "./api";
import StorageService from "./StorageService";

const ClientService = {
  getAll: async (page = 1, limit = 10, filters = {}) => {
    try {
      let url = `/clients?page=${page}&limit=${limit}`;
      const res = await api.get(url);
      return res.data;
    } catch (error) {
      if (error.response && error.response.data) {
        throw new Error(error.response.data.message || "Failed to fetch clients");
      } else {
        throw new Error("Unable to connect to server");
      }
    }
  },

  getById: async (id) => {
    try {
      const res = await api.get(`/clients/${id}`);
      return res.data;
    } catch (error) {
      if (error.response && error.response.data) {
        throw new Error(error.response.data.message || "Failed to fetch client");
      } else {
        throw new Error("Unable to connect to server");
      }
    }
  },

  create: async (data) => {
    try {
      const payload = { ...data, createdBy: StorageService.loginData().employeeId };
      const res = await api.post("/clients", payload);
      return res.data;
    } catch (error) {
      if (error.response && error.response.data) {
        throw new Error(error.response.data.message || "Failed to create client");
      } else {
        throw new Error("Unable to connect to server");
      }
    }
  },

  update: async (id, data) => {
    try {
      const payload = { ...data, updatedBy: StorageService.loginData().employeeId };
      const res = await api.put(`/clients/${id}`, payload);
      return res.data;
    } catch (error) {
      if (error.response && error.response.data) {
        throw new Error(error.response.data.message || "Failed to update client");
      } else {
        throw new Error("Unable to connect to server");
      }
    }
  },

  updateStatus: async (id, status) => {
    try {
      const res = await api.patch(`/clients/${id}/status`, { status, updatedBy: StorageService.loginData().employeeId });
      return res.data;
    } catch (error) {
      if (error.response && error.response.data) {
        throw new Error(error.response.data.message || "Failed to update client status");
      } else {
        throw new Error("Unable to connect to server");
      }
    }
  }
};

export default ClientService;
